/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoUrlForward = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-so-url-forward',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M10.295 3.247a.915.915 0 0 1 1.304.054l4.864 5.346-4.844 5.679a.915.915 0 0 1-1.302.096.943.943 0 0 1-.095-1.318l3.04-3.563H7.537c-1.348 0-2.21.665-2.788 1.561-.594.924-.855 2.064-.903 2.828v7.136a.929.929 0 0 1-.923.934.929.929 0 0 1-.923-.934v-7.192l.002-.027c.058-1.001.383-2.493 1.201-3.765.843-1.31 2.237-2.41 4.334-2.41h5.53l-2.825-3.104a.943.943 0 0 1 .053-1.32Z" }),
            React.createElement("path", { d: "M17.136 3.301a.915.915 0 0 0-1.304-.054.943.943 0 0 0-.054 1.32l3.749 4.12-3.768 4.417c-.333.39-.29.98.095 1.318a.915.915 0 0 0 1.301-.096L22 8.646l-4.864-5.345Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoUrlForward.displayName = 'IconSoUrlForward';
export default IconSoUrlForward;
